import { defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { NumberFormatterFormat } from '../constants.js';

var _numberFormatMap;

// boolean formatting
var parseBoolean = function parseBoolean(value) {
  if (value === true || value === 1) return true;
  if (value === false || value === 0) return false;

  if (typeof value === "string") {
    var lower = value.toLowerCase();
    if (lower === "true" || lower === "1") return true;
    if (lower === "false" || lower === "0") return false;
  }

  return null;
};

var formatBoolean = function formatBoolean(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$parse = options.parse,
      parse = _options$parse === void 0 ? parseBoolean : _options$parse,
      yes = options.yes,
      no = options.no,
      fallback = options.fallback;
  var result = parse(value);
  return result === true ? yes : result === false ? no : fallback;
}; // number formatting

var numberFormatMap = (_numberFormatMap = {}, _defineProperty(_numberFormatMap, NumberFormatterFormat.Default, {
  thousandSeparator: true
}), _defineProperty(_numberFormatMap, NumberFormatterFormat.GBP, {
  decimalPlaces: 2,
  thousandSeparator: true,
  prefix: "£"
}), _defineProperty(_numberFormatMap, NumberFormatterFormat.USD, {
  decimalPlaces: 2,
  thousandSeparator: true,
  prefix: "$"
}), _defineProperty(_numberFormatMap, NumberFormatterFormat.EUR, {
  decimalPlaces: 2,
  thousandSeparator: true,
  prefix: "€"
}), _defineProperty(_numberFormatMap, NumberFormatterFormat.Percentage, {
  decimalPlaces: 1,
  suffix: "%"
}), _defineProperty(_numberFormatMap, NumberFormatterFormat.Kg, {
  thousandSeparator: true,
  suffix: "kg"
}), _numberFormatMap);
var formatNumber = function formatNumber(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$format = options.format,
      format = _options$format === void 0 ? NumberFormatterFormat.Default : _options$format,
      decimalPlaces = options.decimalPlaces,
      thousandSeparator = options.thousandSeparator,
      prefix = options.prefix,
      suffix = options.suffix,
      _options$spaced = options.spaced,
      spaced = _options$spaced === void 0 ? false : _options$spaced,
      language = options.language,
      fallback = options.fallback;

  if (value === undefined || value === null) {
    return fallback;
  }

  var num = Number(value);

  if (Number.isNaN(num)) {
    return fallback;
  }

  var formatProps = numberFormatMap[format];
  var decimalPlacesVal = decimalPlaces !== undefined ? decimalPlaces : formatProps.decimalPlaces;
  var thousandSeparatorVal = thousandSeparator !== undefined ? thousandSeparator : formatProps.thousandSeparator;
  var prefixVal = prefix !== undefined ? prefix : formatProps.prefix;
  var suffixVal = suffix !== undefined ? suffix : formatProps.suffix;
  var fixedDecimalPlaces = typeof decimalPlacesVal === "number" ? decimalPlacesVal : (decimalPlacesVal || {}).fixed;
  var valueString = decimalPlacesVal !== undefined && decimalPlacesVal !== null ? fixedDecimalPlaces !== undefined && fixedDecimalPlaces !== null ? num.toFixed(fixedDecimalPlaces) : num.toLocaleString(language, {
    minimumFractionDigits: typeof decimalPlacesVal === "number" ? decimalPlacesVal : (decimalPlacesVal || {}).min,
    maximumFractionDigits: typeof decimalPlacesVal === "number" ? decimalPlacesVal : (decimalPlacesVal || {}).max
  }) : num.toString();

  if (thousandSeparatorVal) {
    var parts = valueString.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    valueString = parts.join(".");
  }

  var prefixPart = prefixVal ? "".concat(prefixVal).concat(spaced ? " " : "") : "";
  var suffixPart = suffixVal ? "".concat(spaced ? " " : "").concat(suffixVal) : "";
  return "".concat(prefixPart).concat(valueString).concat(suffixPart);
};

export { formatBoolean, formatNumber };
